import Vue from 'vue'
import Router from 'vue-router'

import thankYou from '@/components/layouts/thankYou'
import talentOptimizer from '@/components/landing-pages/talentOptimizer'
import financialInstitutions from '@/components/landing-pages/financialInstitutions'
import globalConsultingReadiness from '@/components/landing-pages/globalConsultingReadiness'
import technologyImplementation from '@/components/landing-pages/technologyImplementation'
import valueBasedCare from '@/components/landing-pages/valueBasedCare'
import governanceAndSecurityMaturity from '@/components/landing-pages/governanceAndSecurityMaturity'
import privacyAndGovernanceMaturity from '@/components/landing-pages/privacyAndDataGovernanceMaturity'
import socialAndCommunityImpact from '@/components/landing-pages/socialAndCommunityImpact'
import error from '@/components/layouts/error'

import main from '@/components/landing-pages/main'


// dataprivacy@	DATA GOVERNANCE AND PRIVACY

Vue.use(Router)

export default new Router({
    mode:'history',
    routes: [  
        {
            path: '',
            beforeEnter() {
                window.open("https://www.anchorgroupcorp.com/about-our-assessments/", '_self');
              },
        },
        {
            path: '/thank-you',
            name: 'thank-you',
            component:thankYou
        },
        {
            path: '/talent-optimizer',
            name: 'talent-optimizer',
            component:talentOptimizer
        },
        {
            path: '/financial-institutions',
            name: 'financial-institutions',
            component:financialInstitutions
        },
        {
            path: '/global-consulting-readiness',
            name: 'global-consulting-readiness',
            component:globalConsultingReadiness
        },
        {
            path: '/technology-implementation',
            name: 'technology-implementation',
            component:technologyImplementation
        },
        {
            path: '/social-and-community-impact',
            name: 'social-and-community-impact',
            component:socialAndCommunityImpact
        },
        {
            path: '/value-based-care',
            name: 'value-based-care',
            component:valueBasedCare
        },
        {
            path: '/it-governance-and-security-maturity',
            name: 'it-governance-and-security-maturity',
            component:governanceAndSecurityMaturity
        },
        {
            path: '/privacy-and-data-governance-maturity',
            name: 'privacy-and-data-governance-maturity',
            component:privacyAndGovernanceMaturity
        },
        { path: '*', beforeEnter: (to, from, next) => { next('/404') } },
        {
            path: '/404',
            name: '404',
            component:error
        }
        
    ]
})
